<template>
    
    <div class="card-container" v-if="isMobile()">

        <Header />      

        <CardBoard 
            :imageArr="imgArr"
            :imageMap="imageMap"
        />  

        <Footer />

        <CardDialog 
            v-if="dialogOpen"
            :selectedImage="selectedImage"
        />
    </div>

    <Warning v-else />
</template>

<script>

    import { 
        toRefs, 
        reactive, 
        getCurrentInstance,
        onMounted,
        onUnmounted 
    } from "vue";
    import { useRouter } from "vue-router";
    import { useStore } from "vuex";

    import CardBoard from "@/components/card-board";
    import Header from "@/components/header";
    import Footer from "@/components/footer";
    import CardDialog from "@/components/card-dialog";
    import Warning from "@/components/warning";

    import HelperMixin from "@/mixins/helper";

    import { useMapState } from "@/utils/store";
    
    export default {
        name: "Card",
        mixins: [ HelperMixin ],
        components: {
            CardBoard,
            Footer,
            Header,
            CardDialog,
            Warning
        },
        setup() {

            const _this = getCurrentInstance().appContext.config.globalProperties;
            const router = useRouter();
            const store = useStore();

            const storeState = useMapState(["imageMap"]);

            const { EVENT, STORE, OTHERS } = _this.$constants;

            const { IMAGE_READY, PUZZLE_SELECT_OPERATION } = EVENT;

            onMounted(() => {
                registerListeners();
            });

            onUnmounted(() => {
                _this.$bus.$off(IMAGE_READY);
            });

            const state = reactive({
                dialogOpen: false,
                selectedImage: null,
                imgArr: OTHERS.imageArr
            });

            const toggleDialog = () => {
                state.dialogOpen = !state.dialogOpen;
            };

            const registerListeners = () => {

                _this.$bus.$on(IMAGE_READY, ({ image }) => {

                    const { back, groupId } = image;

                    state.selectedImage = {
                        ...back,
                        groupId
                    };

                    store.commit(STORE.MUTATION.FLIP, groupId);

                    toggleDialog();
                });

                _this.$bus.$on(PUZZLE_SELECT_OPERATION, ({ type }) => {

                    toggleDialog();

                    switch(type) {
                        case 2:

                            router.replace({
                                name: "Puzzle",
                                query: {
                                    id: state.selectedImage.groupId
                                }
                            });
                    }
                });
            }

            return {
                ...toRefs(state),
                ...storeState,
                registerListeners
            };
        }
    }
</script>

<style lang="scss" scoped>

    .card-container {

        background: url(../assets/card/bg-1.jpg) no-repeat;
        background-position: 50% 50%;
        width: 100vw;
        height: 100vh;

        .card-title {
            width: 15rem;
            height: auto;
            position: fixed;
            left: calc((100% - 15rem) / 2);
            // 消锯齿
            -webkit-backface-visibility: hidden;
            backface-visibility:hidden;
            -webkit-background-clip:content-box;
        }
    }

    @media screen and (min-height: 800px) {
        
        .card-container {
            background-size: auto 100%;
        }
    }

    @media screen and (max-height: 800px) {
        
        .card-container {
            background-size: cover;
        }
    }
</style>